import api from '../../utils/api'

export const state = {
  selectedAgent: undefined,
  appliedFilters: false,
  selectedAgents: [],
  summary: [],
  agentsStartList: [],
  agentsName: [],
  legalConsultationAgentsGroupedByProduct: [],
  summaryMeta: {
    skip: 1,
    limit: 0,
    agents: [],
    acgih: [],
    nr15: [],
    linach: [],
    esocial: [],
    decreto : [],
    products : [],
    typeFilterAgents: '',
    filterForwardedAgents: '',
  },
  agentsNotLinkedToProductAndRoleMeta: {
    skip: 0,
    limit: 30,
    page: 1
  },
  agentsNotLinkedToProductAndRole: [],
  buttons: [],
  exporting: false,
  lookingForAgents: false,
  lookingForAgentsNotLinkedToProductAndRole: false,
  thereAreDuplicateProducts: false,
  duplicateProducts: [],
  skip: false,
  agentsPerPage: 0,
  tabView: 'Summary',
  synergisticRiskProducts: [],
  synergisticRiskRoles: [],
  agentsWithoutProduct: [],
  legalConsultationAgentsPhysicalRisk: [],
  legalConsultationAgentsBiologicalRisk: [],
}

export const mutations = {
  SET_SELECTED_AGENT(state, selectedAgent) {
    state.selectedAgent = selectedAgent
  },
  SET_SUMMARY(state, summary) {
    state.summary = summary
  },
  SET_SUMMARY_META(state, summaryMeta) {
    state.summaryMeta = summaryMeta
  },
  SET_SUMMARY_META_ORDER_BY(state, orderBy) {
    state.summaryMeta.orderBy = orderBy
  },
  SET_EXPORTING(state, exporting) {
    state.exporting = exporting
  },
  SET_SUMMARY_META_SKIP(state, skip) {
    state.skip = skip
  },
  SET_PAGE_AGENTS_NOT_LINKED_TO_PRODUCT_AND_ROLE(state, page) {
    state.agentsNotLinkedToProductAndRoleMeta.page = page
  },
  SET_LOOKING_FOR_AGENTS(state, lookingForAgents) {
    state.lookingForAgents = lookingForAgents
  },
  SET_LOOKING_FOR_AGENTS_NOT_LINKED_TO_PRODUCT_AND_ROLE(state, lookingForAgentsNotLinkedToProductAndRole) {
    state.lookingForAgentsNotLinkedToProductAndRole = lookingForAgentsNotLinkedToProductAndRole
  },
  SET_AGENTS_NOT_LINKED_TO_PRODUCT_AND_ROLE_META(state, agentsNotLinkedToProductAndRoleMeta) {
    state.agentsNotLinkedToProductAndRoleMeta = agentsNotLinkedToProductAndRoleMeta
  },
  SET_AGENTS_NOT_LINKED_TO_PRODUCT_AND_ROLE(state, agentsNotLinkedToProductAndRole) {
    state.agentsNotLinkedToProductAndRole = agentsNotLinkedToProductAndRole
  },
  SET_APPLIED_FILTERS(state, appliedFilters) {
    state.appliedFilters = appliedFilters
  },
  SET_TAB_VIEW(state, tabView) {
    state.tabView = tabView
  },
  SET_SELECTED_AGENTS(state, selectedAgents) {
    state.selectedAgents = selectedAgents
  },
  SET_THERE_ARE_DUPLICATE_PRODUCTS(state, thereAreDuplicateProducts) {
    state.thereAreDuplicateProducts = thereAreDuplicateProducts
  },
  SET_DUPLICATE_PRODUCTS(state, duplicateProducts) {
    state.duplicateProducts = duplicateProducts
  },
  SET_LEGAL_CONSULTATION_AGENTS_GROUPED_BY_PRODUCT(state, legalConsultationAgentsGroupedByProduct) {
    state.legalConsultationAgentsGroupedByProduct = legalConsultationAgentsGroupedByProduct
  },
  SET_SYNERGISTIC_RISK_PRODUCTS(state, synergisticRiskProducts) {
    state.synergisticRiskProducts = synergisticRiskProducts
  },
  SET_SYNERGISTIC_RISK_ROLES(state, synergisticRiskRoles) {
    state.synergisticRiskRoles = synergisticRiskRoles
  },
  SET_AGENTS_WITHOUT_PRODUCT(state, agentsWithoutProduct) {
    state.agentsWithoutProduct = agentsWithoutProduct
  },
  SET_AGENTS_PER_PAGE(state, agentsPerPage) {
    state.agentsPerPage = agentsPerPage
  },
  ADD_AGENT_START_LIST(state, agent) {
    state.agentsStartList.unshift(agent)
  },
  RESET_AGENT_START_LIST(state, agents) {
    state.agentsStartList = agents
  },
  SET_AGENTS_NAME(state, agentsName) {
    state.agentsName = agentsName
  },
  SET_LEGA_LCONSULTATION_AGENTS_PHYSICAL_RISK(state, legalConsultationAgentsPhysicalRisk) {
    state.legalConsultationAgentsPhysicalRisk = legalConsultationAgentsPhysicalRisk
  },
  SET_LEGAL_CONSULTATION_AGENTS_BIOLOGICAL_RISK(state, legalConsultationAgentsBiologicalRisk) {
    state.legalConsultationAgentsBiologicalRisk = legalConsultationAgentsBiologicalRisk
  },
}

export const actions = {
  importList({ commit }, payload) {
    return api.post(`/legal-search/import`, payload)
  },
  importAgentsCompany({ commit }, payload) {
    return api.post(`/legal-search/importAgentsCompany`, payload)
  },
  importAgentsProduct({ commit }, payload) {
    return api.post(`/legal-search/importAgentsProduct`, payload)
  },
  add(_, entry) {
    try {
      return api.post(`/legal-search/`, entry)
    } catch (e) {

    }
  },

  async handleAddBatch(_, body) {
    try {
      return await api.post(`/legal-search/batch`, body)
    } catch (e) {

    }
  },

  async handleBindRoles(_, body) {
    try {
      return await api.post(`/legal-search/bind-roles`, body)
    } catch (err) {
      return { data: { errors: 'Não foi possível vincular o agente aos cargos.' } }
    }
  },
  setSkip({ commit }, skip) {
    commit('SET_SUMMARY_META_SKIP', skip)
  },
  setSlectedAgents({ commit }, selectedAgents) {
    commit('SET_SELECTED_AGENTS', selectedAgents)
  },
  addAgentsStartList({ commit }, agent) {
    commit('ADD_AGENT_START_LIST', agent)
  },
  resetAgentsStartList({ commit }) {
    commit('RESET_AGENT_START_LIST', [])
  },
  async handleGetAgentsName({ commit }, userId) {
    try {
      const { data } = await api.get(`/legal-search/agents-name/${userId}`)
      const agentsName = data && data.legalSearch ? data.legalSearch : []
      commit('SET_AGENTS_NAME', agentsName)
      return agentsName
    } catch (e) {
      commit('SET_AGENTS_NAME', [])
      return []
    }
  },
  summaryClear({ commit }) {
    commit('SET_SUMMARY', [])
    commit('SET_LEGAL_CONSULTATION_AGENTS_GROUPED_BY_PRODUCT', [])
  },
  setLegalConsultationAgentsGroupedByProduct({ commit }, legalConsultationAgentsGroupedByProduct) {
    commit('SET_LEGAL_CONSULTATION_AGENTS_GROUPED_BY_PRODUCT', legalConsultationAgentsGroupedByProduct)
  },
  handleResetSummaryMeta: ({ commit }) => commit('SET_SUMMARY_META', {
    skip: 1,
    limit: 50,
    agents: [],
    acgih: [],
    nr15: [],
    linach: [],
    esocial: [],
    decreto : [],
    products : [],
    typeFilterAgents: ['ACCUMULATED_FILTER'],
    filterForwardedAgents: ['SHOW_ALL']
  }),
  handleSetSummaryMeta({ commit, state }, selectedFilters){
    const { skip, limit} = state.summaryMeta
    const { agents, acgih, nr15, linach, esocial, decreto, products, typeFilterAgents, filterForwardedAgents} = selectedFilters
    localStorage.setItem('summaryMeta', JSON.stringify(selectedFilters));
    const filterSummaryMeta = {
      skip,
      limit,
      agents: agents || [],
      acgih,
      nr15,
      linach,
      esocial,
      decreto,
      products,
      typeFilterAgents,
      filterForwardedAgents,
    }
    commit('SET_SUMMARY_META', filterSummaryMeta)
  },
  handleSetSummaryMetaOrderBy({ commit, state }, orderBy){
    localStorage.setItem('summaryMetaOrderBy', JSON.stringify(orderBy));
    commit('SET_SUMMARY_META_ORDER_BY', orderBy)
  },
  setTabView({ commit }, tabView) {
    commit('SET_TAB_VIEW', tabView)
  },
  setLookingForAgents({ commit }, lookingForAgents) {
    commit('SET_LOOKING_FOR_AGENTS', lookingForAgents)
  },
  async handleGetLoadAgentsByRisk({ commit }, params) {
    try {
      const {userId} = params || {}
      const mutations = {
        'fisico': 'SET_LEGA_LCONSULTATION_AGENTS_PHYSICAL_RISK',
        'biologico': 'SET_LEGAL_CONSULTATION_AGENTS_BIOLOGICAL_RISK',
      }
      const { data } = await api.get(`/legal-search/agents-by-risk/${userId}`, )
      const {data: legalSearchRikPhysical} = data || {}
      commit(
        mutations['fisico'],
        legalSearchRikPhysical && legalSearchRikPhysical.length > 0
        ? legalSearchRikPhysical.filter(x => x.riskType === 'fisico')
        : []
      )
      commit(
        mutations['biologico'],
        legalSearchRikPhysical && legalSearchRikPhysical.length > 0
          ? legalSearchRikPhysical.filter(x => x.riskType === 'biologico')
          : []
      )
    } catch (e) {

    }
  },
  async load({ commit, state }, userId) {
    try {
      commit('SET_LOOKING_FOR_AGENTS', true)
      const body = {
        ...state.summaryMeta,
        skip: state.skip
      }

      console.time('legal-search')
      const { data } = await api.post(`/legal-search/${userId}/paged`, body)

      if (data.legalSearch && data.legalSearch.length > 0) {
        commit('SET_SUMMARY', data.legalSearch)
        const {limit} = data.meta
        commit('SET_AGENTS_PER_PAGE', limit)
        commit('SET_LEGAL_CONSULTATION_AGENTS_GROUPED_BY_PRODUCT', data.legalConsultationAgentsGroupedByProduct)
        commit('SET_SUMMARY_META', data.meta)
      } else {
        commit('SET_SUMMARY', [])
        commit('SET_SUMMARY_META', data.meta)
        commit('SET_LEGAL_CONSULTATION_AGENTS_GROUPED_BY_PRODUCT', [])
      }
      console.timeEnd('legal-search')
      commit('SET_LOOKING_FOR_AGENTS', false)
      const meta = state.summaryMeta;
      commit('SET_APPLIED_FILTERS', !!(
        (meta.agents && meta.agents.length > 0) ||
        (meta.acgih && meta.acgih.length > 0) ||
        (meta.nr15 && meta.nr15.length > 0) ||
        (meta.linach && meta.nr15.length > 0) ||
        (meta.esocial && meta.esocial.length > 0) ||
        (meta.decreto && meta.decreto.length > 0) ||
        (meta.typeFilterAgents && meta.typeFilterAgents === 'SEQUENCED_FILTER') ||
        meta.products.length > 0 ||
        (meta.filterForwardedAgents && meta.filterForwardedAgents === 'SHOW_ONLY_ONCE'))
      )

      commit('SET_THERE_ARE_DUPLICATE_PRODUCTS', false)
      commit('SET_DUPLICATE_PRODUCTS', [])
      const { data: productsDuplicate } = await api.get(`/legal-search/product/${userId}`)
      if (productsDuplicate && productsDuplicate.duplicateProducts && productsDuplicate.duplicateProducts.length > 0) {
        commit('SET_THERE_ARE_DUPLICATE_PRODUCTS', true)
        commit('SET_DUPLICATE_PRODUCTS', productsDuplicate.duplicateProducts)
      }

      const {data: dataSynergisticRisk} = await api.get(`/legal-search/synergisticRisk/${userId}`)
      const {products, roles} = dataSynergisticRisk
      commit('SET_SYNERGISTIC_RISK_PRODUCTS', [])
      commit('SET_SYNERGISTIC_RISK_ROLES', [])
      if (products && products.length > 0) {
        commit('SET_SYNERGISTIC_RISK_PRODUCTS', products)
      }
      if (roles && roles.length > 0) {
        commit('SET_SYNERGISTIC_RISK_ROLES', roles)
      }

      commit('SET_AGENTS_WITHOUT_PRODUCT', [])
      const { data: agentsWithoutProduct } = await api.get(`/legal-search/agents/${userId}`)
      if (agentsWithoutProduct && agentsWithoutProduct.legalSearch && agentsWithoutProduct.legalSearch.length > 0) {
        commit('SET_AGENTS_WITHOUT_PRODUCT', agentsWithoutProduct.legalSearch)
      }
    } catch (e) {
      console.log(e)
    }
  },

  async loadAgentsPreventionistLimits({ commit, state }, userId) {
    try {
      commit('SET_LOOKING_FOR_AGENTS_NOT_LINKED_TO_PRODUCT_AND_ROLE', true)
      const params = {
        ...state.agentsNotLinkedToProductAndRoleMeta
      }

      const { data } = await api.get(`/legal-search/${userId}`, { params })

      if (data.items && data.items.length > 0) {
        commit('SET_AGENTS_NOT_LINKED_TO_PRODUCT_AND_ROLE', data.hierarchy)
        commit('SET_AGENTS_NOT_LINKED_TO_PRODUCT_AND_ROLE_META', data.meta)
      } else {
        commit('SET_AGENTS_NOT_LINKED_TO_PRODUCT_AND_ROLE', [])
        commit('SET_AGENTS_NOT_LINKED_TO_PRODUCT_AND_ROLE_META', {})
      }
      commit('SET_LOOKING_FOR_AGENTS_NOT_LINKED_TO_PRODUCT_AND_ROLE', false)
    } catch (e) {
      console.log(e)
    }
  },
  setPageAgentsNotLinkedToProductAndRole({ commit }, page) {
    commit('SET_PAGE_AGENTS_NOT_LINKED_TO_PRODUCT_AND_ROLE', page)
  },
  async handGetProductByName({ commit}, userId) {
    try {
      commit('SET_THERE_ARE_DUPLICATE_PRODUCTS', false)
      commit('SET_DUPLICATE_PRODUCTS', [])
      const { data } = await api.get(`/legal-search/product/${userId}`)
      if (data && data.legalSearch && data.legalSearch.length > 0) {
        commit('SET_THERE_ARE_DUPLICATE_PRODUCTS', true)
        commit('SET_DUPLICATE_PRODUCTS', data.legalSearch)
      }
    } catch (e) {
      commit('SET_THERE_ARE_DUPLICATE_PRODUCTS', false)
      commit('SET_DUPLICATE_PRODUCTS', [])
    }
  },

  async loadAll(_, body) {
    const { data } = await api.post(`/legal-search/all`, body)
    return data.legalSearch
  },
  async remove({ }, itemsToRemove) {
    await api.post(`/legal-search/delete`, itemsToRemove)
  },
  async handleDeletePhysicalBiologicalRiskAgent({ }, legalSearchId) {
    try {
      return await api.delete(`/legal-search/physical-biological-agents/${legalSearchId}`)
    } catch (err) {
      return { data: { errors: 'Não foi possível excluir o agente.' } }
    }
  },
  async handleGetAgentsWithoutProduct({ state }, userId) {
    try {
      const { agents } = state.summaryMeta || {}
      const params = agents && agents.length > 0 ? { agents: agents.join(',') } : {}
      return await api.get(`/legal-search/${userId}/agents-without-product`, { params })
    } catch (err) {
      return { data: [] }
    }
  },
  async handleGetAgentsWithoutProductPcmso({ state }, userId) {
    try {
      const { agents } = state.summaryMeta || {}
      const params = agents && agents.length > 0 ? { agents: agents.join(',') } : {}
      return await api.get(`/legal-search/${userId}/agents-without-product-pcmso`, { params })
    } catch (err) {
      return { data: [] }
    }
  },
  async importFreeModeAgents({ }, user) {
    await api.post(`/legal-search/import-free-mode-agents/${user}`)
  },
  async notRemove({ }, itemsToRemove) {
    try {
      await api.post(`/legal-search/notDelete`, itemsToRemove)
    } catch (e) {

    }
  },
  async finishInsertionAgents({ }, body) {
    await api.post(`/legal-search/finishInsertionAgents`, body)
  },
  async legalSearch({ }, legalSearchId) {
    return (await api.get(`/legal-search/agent/${legalSearchId}`)).data
  },
  async saveActivities({ }, agent) {
    await api.put(`/legal-search/${agent.legalSearchId}`, agent)
  },
  async saveLegalInterpretation({ }, agent) {
    await api.put(`/legal-search/legal-interpretation/${agent.legalSearchId}`, agent)
  },
  async saveEvaluationForm({ }, evaluationForm) {
    await api.put(`/legal-search/evaluationForm/${evaluationForm.legalSearchId}`, evaluationForm)
  },
  async saveInteractions({ }, agent) {
    await api.put(`/legal-search/interactions/${agent.legalSearchId}`, agent)
  },
  async handUpdatePercentage({ }, payload) {
    return await api.put(`/legal-search/update-percentage`, payload)
  },
  select({ commit }, agent) {
    commit('SET_SELECTED_AGENT', agent)
  },
  async exportingExcel({ commit }, exporting) {
    commit('SET_EXPORTING', exporting)
  },
  async handleUpdateShowLegalSearchTabPreventionLimits(_, body) {
    return await api.post(`/legal-search/update-show-legalSearch-tab-prevention-limits`, body)
  },
  async handleBindRolesToLegalSearch(_, body) {
    try {
      return await api.post('/legal-search/bind-roles', body)
    } catch (err) {
      return { data: { errors: 'Não foi possível vincular o agente aos cargos.' } }
    }
  },
  async handleGetAgentsGroupedByProductAndRisk(_, userId) {
    try {
      return await api.get(`/legal-search/agents-grouped-by-product-and-risk/${userId}`)
    } catch (err) {
      return { data: { errors: 'Não foi possível vincular o agente aos cargos.' } }
    }
  },

}

export const getters = {
  selectedAgent: (state) => state.selectedAgent,
  summary: (state) => state.summary,
  exporting: (state) => state.exporting,
  lookingForAgents: (state) => state.lookingForAgents,
  summaryMeta: (state) => state.summaryMeta,
  agentsPerPage: (state) => state.agentsPerPage,
  appliedFilters: (state) => state.appliedFilters,
  tabView: (state) => state.tabView,
  selectedAgents: (state) => state.selectedAgents,
  thereAreDuplicateProducts: (state) => state.thereAreDuplicateProducts,
  duplicateProducts: (state) => state.duplicateProducts,
  legalConsultationAgentsGroupedByProduct: (state) => state.legalConsultationAgentsGroupedByProduct,
  synergisticRiskProducts: (state) => state.synergisticRiskProducts,
  synergisticRiskRoles: (state) => state.synergisticRiskRoles,
  agentsWithoutProduct: (state) => state.agentsWithoutProduct,
  agentsStartList: (state) => state.agentsStartList,
  agentsName: (state) => state.agentsName,
  agentsNotLinkedToProductAndRoleMeta: (state) => state.agentsNotLinkedToProductAndRoleMeta,
  agentsNotLinkedToProductAndRole: (state) => state.agentsNotLinkedToProductAndRole,
  lookingForAgentsNotLinkedToProductAndRole: (state) => state.lookingForAgentsNotLinkedToProductAndRole,
  legalConsultationAgentsPhysicalRisk: (state) => state.legalConsultationAgentsPhysicalRisk,
  legalConsultationAgentsBiologicalRisk: (state) => state.legalConsultationAgentsBiologicalRisk,
}
